import React from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";

export const NoTransactions: React.FC = () => (
    <EmptyState
        header="No transactions"
        body="It may take a few hours till first transactions are visible."
    />
);
